import { Component, ViewChild, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

import { SubscriptionLike as ISubscription } from 'rxjs';
import { SecurityService, UserInfo, UserExpireInfo } from 'src/app/shared/services/security.service';
import { Configuration } from 'src/app/app.configuration.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
    standalone: false
})
export class HeaderComponent implements OnDestroy {
  @ViewChild('expiringModal') expiringModal: any;
  public username: string;
  public name: string;
  public azureAD: boolean;
  public loginExpireProgress = 100;
  public loginExpirePercentage = 0;
  public expiresLoginPopup = 0;

  private loginExpireSeconds = 0;

  private subUserInfo: ISubscription = null;
  private subUserExpiring: ISubscription = null;
  private handlerModalExpiration: any = null;

  constructor(public configuration: Configuration, private router: Router, private securityService: SecurityService) {
    // subscribe logged user changes
    this.subUserInfo = this.securityService
      .UserInfoSubscribe((userInfo: UserInfo) => {
        if (userInfo) {
          this.username = userInfo.username;
          this.name = userInfo.name;
          this.azureAD = userInfo.azureAD;
        } else {
          this.username = null;
          this.name = null;
          this.azureAD = false;
        }
      });

    // subscribe user about to expire
    this.expiresLoginPopup = this.configuration.expiresLoginPopup;
    if (this.expiresLoginPopup && this.expiresLoginPopup > 0) {
      this.subUserExpiring = this.securityService.UserExpiringSubscribe((userExpireInfo: UserExpireInfo) => {
        if (userExpireInfo && userExpireInfo.totalTimeout && userExpireInfo.timeout) {
          this.loginExpireProgress = Math.floor(userExpireInfo.timeout / userExpireInfo.totalTimeout * 100);
          // console.log('HC1: TOKEN Expiring in % = ' + this.loginExpireProgress);

          if (this.handlerModalExpiration == null && userExpireInfo.timeout / 1000 < this.expiresLoginPopup) { // menos de 50 segundos
            this.loginExpireSeconds = Math.floor(userExpireInfo.timeout / 1000);
            this.loginExpirePercentage = this.loginExpireSeconds / this.expiresLoginPopup * 100;

            this.loginExpireSeconds--;

            this.handlerModalExpiration.result.then((result: string) => {
              const re = 'closed with: ' + result;
              this.handlerModalExpiration = null;
            }, (reason: any) => {
              this.handlerModalExpiration = null;
            });
          }
        } else {
          this.loginExpireProgress = 100;
          this.loginExpirePercentage = 0;
        }
      });
    }
  }

  ngOnDestroy = () => {
    if (this.subUserInfo) { this.subUserInfo.unsubscribe(); }
    if (this.subUserExpiring) { this.subUserExpiring.unsubscribe(); }
  }

  public GetPermission = (lockId: number): boolean => {
    return this.securityService.canDisplay(lockId);
  }

  public logout() {
    this.securityService.logout(true, true);
  }
}
